<script lang="ts">
  const DEFAULT_ZINDEX = 1000;
  import Content from "./Content.svelte";
  let targetRef;

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  const onOpen = () => {
    dispatch("open");
  };

  export let action: string = "click";
  export let zIndex = DEFAULT_ZINDEX;
  export let arrow = true;
  export let placement = "auto";
  export let forcePlacement = false;
  export let arrowColor = "";
  export let overlayColor = null;
  export let extraClass = "";

  export let preventDefault = false;
  export let stopPropagation = false;
  export let widthStyle = "";
  export let popoverElement = "div";

  export let open = false;

  const setOpen: () => void = () => {
    open = !open;
    if (!open) {
      dispatch("close");
    }
  };
  const eventClick = e => {
    if (preventDefault) e.preventDefault();
    if (stopPropagation) e.stopPropagation();

    if (e.type == "touchend" && !forcePlacement) {
      placement = "auto";
    }
    if (e.type == "click") setOpen();
  };
  const eventMouseOut = ({ relatedTarget }) => {
    if (relatedTarget.id === "overlay" && !open) {
      setOpen();
    }
  };

  const onTouchEnd = action === "click" ? eventClick : null;
  const onClick = action === "click" ? eventClick : null;

  const setOpenTrue = () => (open = true);

  const onMouseOver = action === "hover" ? setOpenTrue : null;
  const onMouseOut = action === "hover" ? eventMouseOut : null;

</script>

<style>
  .target {
    display: inline-block;
    position: relative;
  }
  .popover {
    position: relative;
  }

</style>

<!-- prettier-ignore -->
<svelte:element
  this={popoverElement}
  class="popover {extraClass}">
  <div
    bind:this={targetRef}
    class="target"
    style={open ? `z-index: ${zIndex + 10}` : ""}
    on:click={onClick}
    on:touchend={onTouchEnd}
    on:mouseover={onMouseOver}
    on:mouseout={onMouseOut}
    on:blur={onMouseOut}
    on:focus={onMouseOver}
  >
    <slot name="target" {open} {setOpen} />
  </div>
  {#if open}
    <Content
      on:open={onOpen}
      on:setOpen={setOpen}
      {placement}
      {targetRef}
      {zIndex}
      {arrow}
      {action}
      {overlayColor}
      {arrowColor}
      {preventDefault}
      {stopPropagation}
      {widthStyle}
    >
      <slot name="content" {open} {setOpen} />
    </Content>
  {/if}
  <slot {open} {setOpen}></slot>
</svelte:element>
